import React, { useLayoutEffect, useRef } from 'react';

interface PractitionerGameHostProps {
  portalNode: HTMLDivElement | null;
  isActive: boolean;
  isOverlay?: boolean;
}

export const PractitionerGameHost = ({ portalNode, isActive, isOverlay = false }: PractitionerGameHostProps) => {
  const hostRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const hostElement = hostRef.current;
    if (!portalNode || !isActive || !hostElement) {
      return;
    }

    hostElement.appendChild(portalNode);
  }, [isActive, portalNode]);

  return (
    <div
      ref={hostRef}
      style={{
        display: isActive ? 'block' : 'none',
        position: isOverlay ? 'absolute' : 'relative',
        inset: isOverlay ? 0 : undefined,
        width: '100%',
        height: '100%',
      }}
    />
  );
};
